import { shallowEqual, useSelector } from 'react-redux';
import { dictionaryMap } from '../../assets/dictionaries/dictionary';

export const useBookingChannels = () => {
	const { user } = useSelector(
		({ auth }) => ({
			user: auth.user
		}),
		shallowEqual
	);

	let dictionary = user ? dictionaryMap[user.language_id] : dictionaryMap[143];

	return {
		1: {
			id: 1,
			text: dictionary.marketplace
		},
		2: {
			id: 2,
			text: dictionary.website
		},
		3: {
			id: 3,
			text: dictionary.reselling
		},
		4: {
			id: 4,
			text: dictionary.offline
		}
	};
};
